<kendo-expansionpanel [title]="'Order #' + orderNumber + ' - ' + orderStatus"
                      [subtitle]="''"
                      [expanded]="true">
    <div class="row" *ngIf="quoteOrderID > 0">
        <div class="col-sm-4">
            <div class="row">
                <div class="col-sm-12">
                    <div class="ot-progress">
                        <div class="circle" [ngClass]="{'active': orderStatus == 'Planned', 'done': orderStatus != 'Planned'}">
                            <span class="label" [innerHtml]="plannedLabel"></span>
                            <span class="title">Planned</span>
                        </div>
                        <span class="bar" [ngClass]="{'active': orderStatus == 'Planned', 'done': orderStatus != 'Planned'}"></span>
                        <div class="circle" [ngClass]="{'active': orderStatus == 'In Transit', 'done': orderStatus == 'Delivered'}">
                            <span class="label" [innerHtml]="inTransitLabel"></span>
                            <span class="title">In Transit</span>
                        </div>
                        <span class="bar" [ngClass]="{'active': orderStatus == 'In Transit', 'done': orderStatus == 'Delivered'}"></span>
                        <div class="circle" [ngClass]="{'done': orderStatus == 'Delivered'}">
                            <span class="label" [innerHtml]="deliveredLabel"></span>
                            <span class="title">Delivered</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <h3>From</h3>
                    <p *ngIf="shipper.customerName">
                        <label>{{shipper.customerName}}</label><br />
                        {{shipper.address1}}<br />
                        {{shipper.cityStateZip}}
                    </p>
                </div>
                <div class="col-sm-6">
                    <h3>To</h3>
                    <p *ngIf="consignee.customerName">
                        <label>{{consignee.customerName}}</label><br />
                        {{consignee.address1}}<br />
                        {{consignee.cityStateZip}}
                        <
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2">
                    <b>Ref #s:</b>
                </div>
                <div class="col">
                    <reference-number-grid [quoteOrderID]="quoteOrderID" [readonly]="true"></reference-number-grid>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <order-stop-card [quoteOrderID]="quoteOrderID" [isCustomer]="true" [isDisplayEventDescription]="true"></order-stop-card>
                </div>
            </div>
        </div>
        <div class="col-sm-8">
            <div class="row">
                <div class="col">
                    <div style="height:600px;">
                        <openlayers-map [quoteOrderID]="quoteOrderID"></openlayers-map>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <kendo-expansionpanel [title]="'Tracking Update'"
                                          [subtitle]="''"
                                          [expanded]="true">
                        <check-call-grid [quoteOrderID]="quoteOrderID"
                                         [viewType]="'order-tracking'"
                                         [isCustomer]="true"
                                         [isDisplayLocationOnly]="true"
                                         [isDisplayEventDescription]="true">
                        </check-call-grid>
                    </kendo-expansionpanel>
                </div>
            </div>
        </div>
    </div>
</kendo-expansionpanel>
